const palyNotifyTone = () => {
    const audio = new Audio("./music/order_notify.mp3");
    // audio.play()
      audio.play().catch(e => console.error("Audio play failed:", e));

    // if(status){
    // }else{
    //     audio.pause()
    // }
}

export{
    palyNotifyTone
}